// import lodash from 'lodash'
import axios from 'axios'
import { Spin, Message } from 'iview'
import { MessageBox } from 'element-ui'
import { getToken, setToken } from '@/tools/auth'
import Vue from 'vue'
import {getServiceName} from '@/utils'

const service = axios.create({
  // baseURL: process.env.BASE_URL,
  timeout: 1000 * 60
})
service.defaults.headers.post['Content-Type'] = 'application/json'
// request interceptor
service.interceptors.request.use(
  config => {
    const { showLoading = true, timeout = 1000 * 60 } = config.opts || {}
    // 判断外部配置文件的地址是否存在
    // config.baseURL = axios.prototype.$VUE_APP_BASE_API || process.env.BASE_URL
    if (config.baseUrl) {
      config.baseURL = config.baseUrl
    } else {
      config.baseURL = getServiceName(Vue.prototype.$VUE_APP_BASE_API)
    }

    config.timeout = timeout
    if (showLoading && !location.pathname.includes('bot.html')) {
      // 排除对答式loading
      Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '加载中...')
          ])
        }
      })
    }

    // 指定平台/租户
    const TENANT = axios.prototype.$TENANT
    if (TENANT && TENANT !== '') {
      config.headers['tenant'] = TENANT
    }

    // config.headers['token'] = getToken()
    const { method } = config
    if (method === 'post') {
    } else if (method === 'get') {
      config.params = config.data
    }
    return config
  },
  error => {
    Spin.hide()
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const opts = response.config.opts
    let showError = true
    if (opts) {
      showError = opts.showError
    }
    Spin.hide()
    const res = response.data

    const { code, msg } = res
    let data = res.data || {}
    // 220008-回收问卷达到年度上线,请知悉 300004-问卷信息不存在 220013-二维码投放未开启！
    // 220019-该手机号已经答题，220018-该身份证号已经答题，220020-手机号前n位重复，220022-配额超限
    if ([220008, 300004, 220013, 220019, 220018, 220020, 220022].includes(code)) {
      return res
    }
    if (code !== 200) {
      showError !== false && Message.warning(msg || '系统错误')
      return Promise.reject(msg)
    }
    const token = data.token
    if (token) {
      setToken(token)
    }
    return data
  },
  error => {
    Spin.hide()
    console.log('err' + error)
    Message.error('网络请求失败，请稍后再试')
    return Promise.reject(error)
  }
)

export default service

/*

axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true

const fetch = (options) => {
  let { method = 'get', data, url, timeout = 10000 } = options
  const cloneData = lodash.cloneDeep(data)
  try {
    let domin = ''
    if (url.match(/[a-zA-z]+:\/\/[^/]*!/)) {
      domin = url.match(/[a-zA-z]+:\/\/[^/]*!/)[0]
      url = url.slice(domin.length)
    }
    const match = pathToRegexp.parse(url)
    url = pathToRegexp.compile(url)(data)
    for (let item of match) {
      if (item instanceof Object && item.name in cloneData) {
        delete cloneData[item.name]
      }
    }
    url = domin + url
  } catch (e) {
    console.log(e)
  }
  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, {
        params: cloneData,
        timeout
      })
    case 'delete':
      return axios.delete(url, {
        data: cloneData
      })
    case 'post':
      return axios.post(url, cloneData)
    case 'put':
      return axios.put(url, cloneData)
    case 'patch':
      return axios.patch(url, cloneData)
    default:
      return axios(options)
  }
}

export default function request (options) {
  const showLoading = options.showLoading
  if (showLoading !== false) {
    Spin.show({
      render: (h) => {
        return h('div', [
          h('Icon', {
            'class': 'demo-spin-icon-load',
            props: {
              type: 'ios-loading',
              size: 18
            }
          }),
          h('div', '加载中...')
        ])
      }
    })
  }
  return fetch(options)
    .then(ret => {
      ret = ret.data
      if (showLoading !== false) {
        Spin.hide()
      }
      const { data, code, message } = ret
      if (code !== 200) {
        MessageBox.alert(message || '系统错误', '出错啦', {
          type: 'warning'
        })
        return Promise.reject(message)
      }
      return data
    })
    .catch(err => {
      Spin.hide()
      const msg = err || '网络错误，请稍候再试！'
      MessageBox.alert(msg, '出错啦', {
        type: 'error'
      })
      return Promise.reject(msg)
    })
} */



// WEBPACK FOOTER //
// ./src/tools/request.js